<template>
  <tr :class="rowColor || ''">

    <td :class="imageWidthClass + tdClass" v-if="!xs && !hideIconColumn">
      <Player v-if="isPlaying"
        :reason="itemReason"
        :poster="image"
        autoplay
        :master="master"
      ></Player>
      <image-icon v-else
        :image="image"
        :row-type="rowType"
        @play-it-detail="selectedImage"
        :avatar=avatar
        play-it="play-it-detail"
      ></image-icon>
    </td>
    <td v-if="vimeoUserVideoRow && !xs" :class="tdClass">
      <vimeo-connect-fid :matchReason="itemReason"></vimeo-connect-fid>
    </td> 

    <td :class="reasonAlignClass + tdClass">
      <div :class="imageWidthClass" v-if="xs">
        <Player v-if="isPlaying"
          :reason="itemReason"
          :poster="image"
          autoplay
          :master="master"
        ></Player>
        <image-icon v-else
          :image="image"
          :row-type="rowType"
          @play-it-detail="selectedImage"
          :avatar=avatar
          play-it="play-it-detail"
        ></image-icon>
      </div>

      <v-icon v-if="isPlaying"
        color="accent"
        @click="stopPlaying"
      >
        stop
      </v-icon>

      <span>
        <Matches
          :match-reasons="matchReasons"
          :compressed="compressed"
          :row-type="rowType"
          :story="story"
        ></Matches>
        <vimeo-connect-fid v-if="vimeoUserVideoRow && xs"
          :matchReason="itemReason"
        ></vimeo-connect-fid>
      </span>
    </td>



    <td v-if="mergeButton" :class="tdClass">
      <v-tooltip 
        left
        color="accent" 
        content-class="caption" 
        :close-delay="tooltips.closeDelay"
        :open-on-hover="true"
        :transition="tooltips.transition">
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <v-btn icon :disabled="isThisFilm" @click="emitMerge">
              <v-icon>merge_type</v-icon>
            </v-btn>
          </div>
        </template>
        <span v-if="isThisFilm">{{mergeIntoName}} is the current film</span><span v-else>Merge {{filmName}} into {{mergeIntoName}}</span>
      </v-tooltip>
    </td>

    <td v-if="score" :class="tdClass">
      <tool-chip-count
        :count="itemScore"
        class="mr-1"
        :tooltip="`${toolText}`"
        left
        postFix="%"
        :colorName="itemColor"
        ></tool-chip-count>
    </td>

  </tr>
</template>
<script>
import Matches from '@/components/Matches'
import Imageicon from '@/components/Imageicon'
import Vimeoconnectfid from '@/components/Vimeoconnectfid'
import Toolchipcount from '@/components/Toolchipcount'
import { SearchUtils } from '@/js'
import Player from '@/components/Player'
import { mergeControls } from '@/js/apollo'
import { Controls } from '@/gql'
import { settings } from '@/js/store'
export default {
  components: {
    Matches,
    Player,
    'image-icon': Imageicon,
    'vimeo-connect-fid': Vimeoconnectfid,
    'tool-chip-count': Toolchipcount
  },
  props: {
    mergeInto: Object,
    mergeButton: Boolean,
    score: Boolean,
    rowColor: String,
    hideIconColumn: Boolean,
    compressed: Boolean,
    item: Object,
    imageColumn: Boolean,
    rowType: {
      type: String,
      required: true
    },
    allPrizes: Array,
    itemType: {
      type: String,
      required: true
    },
    playerInstance: {
      type: String,
      default: ''
    }
  },
 
  data: () => ({
    Controls: {}
  }),
  methods: {
    emitMerge () {
      this.$emit('merge',  this.itemReason)
    },
    stopPlaying () {
      mergeControls({
        playing: ''
      })
    },
    selectedImage () {
      if (this.isFilm) {
        mergeControls({
          playing: this.playingID
        })
      } else {
        this.stopPlaying()
        SearchUtils.routeChange({ router: this.$router, reason: this.patchReason })
      }
    }
  },

  computed: {
    master () {
      return this.itemReason && 
        this.itemReason && 
        this.itemReason.Film && 
        this.itemReason.Film.FilmMasters && 
        this.itemReason.Film.FilmMasters[0]
    },
    tooltips () {
      return settings.tooltips
    },
    filmName () {
      return this.item && this.item.itemReason && this.item.itemReason.match
    },
    itemScore () {
      const s = this.item && this.item.score && this.item.score * 100
      return (s && Math.round(s)) || null
    },
    isThisFilm () {
      return this.item && this.item.isThisFilm
    },
    mergeIntoName () {
      return this.mergeInto && this.mergeInto.Film && this.mergeInto.Film.filmName
    },
    toolText () {
      return `${this.itemScore}% matching content` + (this.isThisFilm ? '(this film)' : '')
    },
    itemColor () {
      return this.item && this.item.colorName
    },
    vimeoUserVideoRow () {
      return (this.itemReason && this.itemReason.matchType === 'vimeofilm') && !this.compressed
    },
    xs () {
      return this.$vuetify.breakpoint.xs
    },
    bigEnough () {
      return this.$vuetify.breakpoint.mdAndUp
    },
    // this is because we want to masquerade a reason as a different type to pass off to the router which is showing a different type
    // this will copy the same behavior as when clicked from a reason chip
    patchReason () {
      return { ...this.itemReason, matchType: this.item.itemType, matchID: this.item.itemID, match: this.item.itemName }
    },
    avatar () {
      return this.compressed || !this.isFilm || !this.image
    },
    tdClass () {
      return (this.bigEnough ? '' : ' fid-td-sm') + ' fid-td-spacer'
    },
    imageWidthClass () {
      return this.avatar ? 'fid-avatar-width' : (this.bigEnough ? 'fid-player-width' : 'fid-player-width-sm')
    },
    reasonAlignClass () {
      return this.compressed ? 'text-xs-right fid-avatar-center' : 'text-xs-left fid-avatar-center'
    },
    isFilm () {
      return this.rowType === 'film' || this.rowType === 'vimeofilm'
    },
    playingID () {
      const ir = this.itemReason
      return ir && ('detail' + ir.matchType + ir.matchID + this.playerInstance)
    },
    isPlaying () {
      return this.Controls.playing === this.playingID
    },
    matchReasons () {
      return this.item.MatchReasons
    },
    itemReason () {
      if (!this.item) return null
      const { itemReason } = this.item
      if (!itemReason && this.item.MatchReasons.length) {
        console.log('itemreason missing', this.item)
        return null
      }
      return itemReason
    },
    image () {
      const img= SearchUtils.getImageFromReason({
        reason: this.itemReason,
        rowType: this.rowType,
        minHeight: settings.dimensions.posterFrameHeight
      })
      return img;
    },
    storyType () {
      return this.itemType === 'award' ? 'award' : this.rowType
    },
    story () {
      // if we are doing award, no matter the row type, would like to get the story about the awards rather than the natural story
      return SearchUtils.getStoryFromReason({
        reason: this.itemReason,
        rowType: this.storyType,
        allPrizes: this.allPrizes
      })
    }
  },
  name: 'Itemrowdetail',
  apollo: {
    Controls: {
      query: Controls
    }
  }
}
</script>
